import ActivityBasedTimer from '../services/ActivityBasedTimer'
import axios from 'axios';

// Version 1.51.2
export const refreshPageMixin = {
    data() {
        return {
            filename: '/index.html',
            currentHash: null,
            versioningTimer: null,
        }
    },
    methods: {
        initVersionCheck: async function() {
            this.versioningTimer = new ActivityBasedTimer();
            this.currentHash = await this.getFileHash();

            const self = this;
            this.versioningTimer.setInterval({
                async callback() {
                    console.log('Version callback entered');
                    const newVersionAvailable = await self.isNewerVersionAvailable();
                    console.log('Finished callback');
                    if (!newVersionAvailable) {
                        console.log('No new version');
                        return;
                    }

                    console.log('New version available - notify');
                    self.$root.$emit("new-version-available");
                },
                // Normal interval is once every 10 minutes
                // interval: 1000 * 60 * 10,
                interval: 1000 * 60 * 1,

                // Forced interval is once per day
                forcedInterval: 1000 * 60 * 60 * 24,
            });
        },
        isNewerVersionAvailable: async function() {
            console.log("Checking for new version of app");
            const hash = await this.getFileHash();
            // if we can't get a hash, assume it's not changed
            if (!hash) {
                console.log("No file hash");
                return false;
            }
            // if we haven't yet stored a hash, do so
            if (!this.currentHash) {
                console.log("No stored hash");
                this.currentHash = hash;
                return false;
            }
            return this.currentHash !== hash;
        },
        getFileHash: async function() {
            try {
                const fileResponse = await axios.get(`${this.filename}?t=${new Date().getTime()}`);
                return fileResponse.data.hashCode();
            } catch (error) {
                if (!error.response) {
                    console.log('Error: Network Error');
                } else if (error.response.status === 404) {
                    console.log('Error: File not found');
                } else {
                    console.log('Error: ' + error.response.data.message);
                }
                return null;
            }
        },
        reloadApp: function() {
            window.location.reload();
        }
    }
};